import { render, staticRenderFns } from "./ProfileChangePass.vue?vue&type=template&id=aa033fb6&scoped=true&"
import script from "./ProfileChangePass.vue?vue&type=script&lang=js&"
export * from "./ProfileChangePass.vue?vue&type=script&lang=js&"
import style0 from "./ProfileChangePass.vue?vue&type=style&index=0&id=aa033fb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa033fb6",
  null
  
)

export default component.exports